import * as types from "../action/ActionType";
import { ALL_CUSTOMER_INITIAL } from "../store/InitialStore";
export default function AllCustomerListReducer(state = ALL_CUSTOMER_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.ALL_CUSTOMERS_LIST:
      return (state = payload);
    default:
      return state;
  }
}
